import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';

const InstallationRequestListing = ({ 
  installationDateChangeListing = null, 
  getInstallationDateChangeListing,
  match
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const headers = [
    'Site No.',
    'Client Name',
    'Site Created By',
    'Initial Installation Date',
    'Current Installation Date',
    'Requested Installation Date',
    'Raised By',
    'Raised On',
    'Action taken By',
    'Action taken On',
    'Remarks',
    'Attachment',
    'Status',
  ];

  useEffect(() => {
    (async () => {
        setIsLoading(true);
        const res=await getInstallationDateChangeListing(1,match.params.comm_id,null);
        setListData(res?.original)
        setIsLoading(false);
      })();

  }, []);

  useEffect(() => {
    const tableData = [
      "id",
      "site_no",
      "client_name",
      "site_created_by",
      "initial_date",
      "old_date",
      "changed_date",
      "created_by",
      "created_at",
      "approved_by",
      "approved_on",
      "request_remarks",
      "attachment",
      'status'
    ];
    
    
    if (installationDateChangeListing && installationDateChangeListing?.data) {
      const data = installationDateChangeListing?.data?.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                key === 'attachment'
                    ? { [key]: element[key] ? <a href={`${element[key]}`} target="_blank" rel="noopener noreferrer">Attachment</a> : 'NA' }
                    : { [key]: element[key] }
              ))
          )
      );
      data && setListData(data);
      
      setPageCount(Math.ceil(installationDateChangeListing?.total / installationDateChangeListing?.per_page));
    }
  }, [installationDateChangeListing]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getInstallationDateChangeListing(val.selected + 1,match.params.comm_id,null);
    localStorage.setItem('page', val.selected + 1)
    setIsLoading(false);
  };
  return (
    <Layout
      title={'Request Listing'}
      isGoback
      isLoading={isLoading}
    >
    <div className="container my-5">
      <div className="row mt-4">
            <div className="col-md-12">
              
                  <TableSection
                    data={listData}
                    isId={false}
                    srNo={installationDateChangeListing?.from}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                  />
            </div>
          </div>
        </div>

    </Layout>
  );
}; 

InstallationRequestListing.propTypes = {
  installationDateChangeListing: PropTypes.any, 
  getInstallationDateChangeListing: PropTypes.func,
  match: PropTypes.any
};


export default InstallationRequestListing;
